import type { ContributionSegment, PensionInput, ScenarioAssumption, UserProfile } from "../types";

export const sampleProfile: UserProfile = {
  birthMonth: "1988-06",
  gender: "female",
  originalRetirementAgeType: "female55",
  hukouRegionCode: "CN-42",
  currentInsuranceRegionCode: "CN-31",
  knownAccountBalance: 96000,
  knownAccountBalanceMonth: "2026-06",
  deemedContributionMonths: 0
};

export const sampleSegments: ContributionSegment[] = [
  {
    id: "seg-1",
    regionCode: "CN-42",
    startMonth: "2012-07",
    endMonth: "2016-12",
    participantType: "employee",
    paymentStatus: "paid",
    monthlySalary: 7200,
    contributionBase: 7200
  },
  {
    id: "seg-2",
    regionCode: "CN-11",
    startMonth: "2017-01",
    endMonth: "2020-06",
    participantType: "employee",
    paymentStatus: "paid",
    monthlySalary: 18000,
    contributionBase: 18000
  },
  {
    id: "seg-3",
    regionCode: "CN-11",
    startMonth: "2020-07",
    endMonth: "2021-02",
    participantType: "unemployed",
    paymentStatus: "interrupted",
    monthlySalary: 0,
    contributionBase: 0
  },
  {
    id: "seg-4",
    regionCode: "CN-31",
    startMonth: "2021-03",
    endMonth: "2026-06",
    participantType: "employee",
    paymentStatus: "paid",
    monthlySalary: 26000,
    contributionBase: 26000
  }
];

export const scenarioPresets: ScenarioAssumption[] = [
  {
    name: "继续缴至法定退休",
    futureRegionCode: "CN-31",
    contributionUntil: "legalRetirement",
    salaryGrowthRateAnnual: 0.04,
    wageGrowthRateAnnual: 0.035,
    accountInterestRateAnnual: 0.03,
    baseStrategy: "actualSalary"
  },
  {
    name: "现在停缴",
    futureRegionCode: "CN-31",
    contributionUntil: "stopNow",
    salaryGrowthRateAnnual: 0,
    wageGrowthRateAnnual: 0.03,
    accountInterestRateAnnual: 0.025,
    baseStrategy: "actualSalary"
  },
  {
    name: "按 100% 社平缴费",
    futureRegionCode: "CN-31",
    contributionUntil: "legalRetirement",
    salaryGrowthRateAnnual: 0.03,
    wageGrowthRateAnnual: 0.035,
    accountInterestRateAnnual: 0.03,
    baseStrategy: "p100"
  }
];

export const sampleInput: PensionInput = {
  profile: sampleProfile,
  segments: sampleSegments,
  assumption: scenarioPresets[0]
};
